export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'DASHBOARD': 'Dashboard',
            'APPLICATIONS': 'Applications',
            'USER': 'User Name',
            'JOB': 'Job',
            'INFRA': 'Infrastructure',
            'SETTING': 'Configurations',
            'MODULE': {
                'TALKING': 'Talking',
                'USAGE': 'Usage',
                'INVENTORY': 'Inventory',
                'VOICEBIOMETRIC': 'Voice Biometric',
                'GEO': 'Geolocation',
                'REALTIME' : 'Realtime',
                'VOICE_BIOMETRIC': 'Voice Biometric'
            },
            'PROFILE': 'Profile'
        },        
        'REALTIME': {
            'REALTIME': 'Realtime',
            'PRESENCE': 'Presence',
            'LIVE': 'Live',
            'ONLINE': 'On Line',
            'OFFLINE': 'Off Line',
            'INCALL': 'In Call',
            'INMUTE': 'In Mute',
            'HEADSETS': 'Headsets',
            'HEADSET': 'Headset'
        },
        'TALKING': {
            'TALKING': 'Talking',
            'HOME': 'Home',
            'SUMMARY': 'Summary',
            'TEAM_MEMBERS': 'Team Members',
            'TARGET': 'Target',
            'CALLS': 'Calls',
            'TOTAL_CALL_USER': 'TOTAL CALLS PER USER',
            'TOTAL_CALL_TIME': 'TOTAL CALL TIME',			
            'TOTAL_SPEAK_TIME': 'TOTAL TALK TIME',
            'TOTAL_MUTE_TIME': 'TOTAL MUTE TIME',
            'TOTAL_CALLS': 'TOTAL NUMBER OF CALLS',
            'LIVE': 'Live',
            'NAME': 'Operator',
            'USER': 'Operator',
            'SHORT': 'Short',
            'LONG': 'Long',
            'SHORT_SING': 'Short Sing',					
            'LONG_SING': 'Long Sing',				
            'TMA': 'Answer Mean Time ',
            'TMF': 'Talk Mean Time',
            'TMM': 'Mute Mean Time',
            'TTA': 'Total Answer Time',
            'TA': 'Answer Time',
            'TF': 'Talk Time',
            'TM': 'Mute Time',
            'CALL_DETAIL': 'Call Detail',				
            'PERIOD': 'Period',
            'MAP': 'Map'
        },
        'USAGE' : {
            'USAGE' : 'Usage',
            'USAGE_TIME' : 'Usage (ON) Time',
            'CALL_TIME' : 'Call Time',
            'MUTE_TIME' : 'Mute Time',
            'DISCONNECTIONS' : 'Disconnections',
            'MODELS': 'MODELS',
            'HEADSET_USED': 'HEADSETS UTILIZED',
            'DISCONNECTIONS_UPPER': 'UPPER DISCONNECTIONS',
            'TOTAL_USER': 'HOURS IN USE PER OPERATOR',
            'TOTAL_USAGE': 'HOURS ON LINE',
            'TOTAL_SPEAK': 'TOTAL TALK TIME',
            'TOTAL_MUTE': 'TOTAL MUTE TIME',
            'ON' : 'ON',
            'CALL': 'USE',
            'MUTE' : 'MUTE',
            'PAS': 'APs',
            'COMPUTER': 'COMPUTER',
            'TOTAL_MODEL': 'HOURS OF USAGE PER MODEL',
            'TOTAL_USAGE_CALL': 'TOTAL USAGE TIME / USAGE/ MUTE',
            'CONTROL_TIME': 'Control Time',
            'HEADSET_TIME': 'Headset Time',
            'TOTAL_COMPUTER': 'Total Usage Per Position'

        },
        'INVENTORY' : {
            'INVENTORY' : 'Inventory',
            'HEADSETS' : 'Headsets',
            'ACTIVE' : 'ACTIVE',
            'INACTIVE' : 'INACTIVES',
            'OUT_OF_SERVICE' : 'OUT OF SERVICE',
            'CONNECTED' : 'CONNECTED',
            'DISCONNECTED' : 'DISCONNECTED',
            'DISCONNECTIONS' : 'DISCONNECTIONS',
            'MODELS': 'MODELS UTILIZED',
            'HEADSET_USED': 'HEADSETS UTILIZED',
            'TOTAL_USAGE': 'TOTAL USAGE TIME',
            'DISCONNECTIONS_UPPER': 'DISONNECTIONS UPPER',
            'PRODUCT_NAME': 'PRODUCT NAME',
            'SERIAL': 'Serial',
            'HEADSET_STATUS': 'Headset Status',
            'HEADSET_FIRST_CONN': 'Headset First Connection',
            'HEADSET_LAST_CONN': 'Headset Last Connection',
            'USER_NAME': 'User Name',
            'COMPUTER_NAME': 'Desktop',
            'INFRA_NAME': 'Infra',
            'HEADSET_MODEL': 'HEADSETS PER MODEL',
            'HEADSET_ACTIVE': 'ACTIVES / INACTIVES / NO USE',
            'MANUFACTURER': 'MANUFACTURER',
            'QTD': 'Quantity',
            'USAGE': 'USAGE'
        },
        'BUTTONS': {
            'DELETE': 'DELETE',
            'SAVE': 'SAVE',
            'ADD': 'ADD'
        },
        'SETTINGS': {
            'SETTINGS': 'SETTINGS',
            'INVENTORY': 'INVENTORY',
            'USAGE': 'USAGE',
            'BEEP_MUTE_ALERT': 'MUTE ALERT BEEP',
            'MODULES': 'MODULES',
            'NAME': 'NAME',
            'EDIT': 'EDIT CONFIGURATION',
            'NEW': 'NEW CONFIGURATION',
            'SOFTPHONE': 'SOFTPHONE',
            'SOUNDS': 'SOUNDS',
            'BEEP_VOLUME': 'VOLUME BEEP',
            'BEEP_MUTE_ON': 'MUTE ON BEEP',
            'BEEP_MUTE_OFF': 'MUTE OFF BEEP',
            'AUDIO' : 'Audio',
            'GAIN_MIN': 'MINIMUM GAIN',
            'GAIN_MAX': 'MAXIMUM GAIN',
            'MUTE': 'MUTE',
            'MUTE_ON': 'MUTE ON',
            'MUTE_CONTROL': 'MUTE CONTROL',
            'MAX_MUTE_TIME': 'MAXIMUM MUTE TIME',
            'MUTE_ALERT': 'MUTE ALERT',				
            'CALLS': 'CALLS',
            'TMA_TARGET': 'Answer Mean Time TARGET',
            'TMM_TARGET': 'Mute Mean Time TARGET',
            'SHORT_CALL': 'SHORT CALLS',
            'LONG_CALL': 'LONG CALLS',
            'INVENTORY_DAYS_ACTIVE': 'ACTIVE INVENTORY (DAYS)',
            'INVENTORY_DAYS_INACTIVE': 'OUT OF SERVICE (DAYS)',
            'TALKING': 'Talking',
            'STUDIO': 'Studio',
            'VOICE': 'Voice',
            'GENERAL': 'General',
            'PRESENCE_TIME': 'PRESENCE TIME',
            'GEO_TIME': 'GEOLOCATION TIME',
            'NOISE_OFF': 'Noise Off',
            'OUT_NOISE': 'Noise Out',
            'OUT_AUDIO': 'Audio Out',
            'OUT_BLOCK': 'BLOCK Out',
            'DISCONNECTIONS': 'DISCONNECTIONS PER HOUR',
            'VOICE_VOICE_CONFIDENCE': 'VOICE CONFIDENCE',
            'VOICE_TEXT_CONFIDENCE': 'TEXT CONFIDENCE',
            'OUT_EFFECT': 'STANDARD EFFECT'
        },
        'INFRA': {
            'INFRA': 'INFRASTRUCTURE',
            'NAME': 'OPERATION',
            'EDIT': 'EDIT OPERATION',
            'NEW': 'NEW OPERATION',
            'NETWORK': 'NETWORK',
            'HOMEOFFICE': 'HOME OFFICE',
            'INLOCO': 'IN LOCO',
            'PAS': 'APs'
        },
        'COMPUTER': {
            'EDIT': 'CHANGE AP',
            'NAME': 'AP',
            'POSITION': 'POSITION',
            'HOMEOFFICE': 'Home Office',
            'SO': 'OPERATIONAL SYSTEM',
            'IP': 'IP',
            'MACADDRESS': 'MAC Address',
            'VERSION': 'VERSION',
            'LICENCE': 'LICENCE',
            'DTH_LICENCE': 'EXPIRATION DATE'
        },
        'USER': {
            'USER': 'USER'
        },
        'AGENT': {
            'NAME': 'OPERATOR',
            'USERNAME': 'USER NAME',
            'DOMAIN': 'DOMAIN'
        },
        'GEO': {
            'MAP': 'MAP',
            'ADDRESS': 'ADDRESS',
            'GEOLOCATION' : 'GEOLOCATION',
            'NOTLOCATION' : 'NO LOCATION'				
        },
        'PROFILE': {
            'PROFILE': 'Profile',
            'LOCATION': 'LOCATION'
        },
        'VOICE_BIOMETRIC': {
            'VOICE_BIOMETRIC' : 'VOICE BIOMETRIC',
            'FINISHED': 'REGISTERED',
            'SUCCESS': 'VERIFICATION SUCCESS',
            'USERS': 'USERS',
            'FAILS': 'VERIFICATION FAILURES'
        }
    }
};
